import dynamic from 'next/dynamic';
import type React from 'react';

import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';
import { ENABLE_REDESIGN_TOP_SPONSORED_PRODUCT } from '@/sellerAdsManagement/SponsoredProducts/components/TopBannerProduct/constants';
import { useTopProductsSponsoredData } from '@/sellerAdsManagement/SponsoredProducts/components/TopBannerProduct/hooks/useTopProductsSponsoredData';

const TopBannerProduct = dynamic(
  () => import('./TopBannerProduct').then((mod) => mod.TopBannerProduct),
  {
    ssr: false,
    loading: () => <div style={{ height: '58px' }} />,
  },
);
const RedesignedTopSponsoredProduct = dynamic(
  () =>
    import(
      './RedesignedTopSponsoredProduct/RedesignedTopSponsoredProduct'
    ).then((mod) => mod.RedesignedTopSponsoredProduct),
  {
    ssr: false,
    loading: () => <div style={{ height: '58px' }} />,
  },
);

export const TopBannerProductContainer: React.FC = () => {
  const [isTopSponsoredProductRedesignEnabled] = useBooleanFlags([
    ENABLE_REDESIGN_TOP_SPONSORED_PRODUCT,
  ]);
  const { productId } = useDetail();
  const topProductsSponsoredData = useTopProductsSponsoredData();

  if (!topProductsSponsoredData.length) return null;

  return isTopSponsoredProductRedesignEnabled ? (
    <RedesignedTopSponsoredProduct
      key={`top-product-${productId}`}
      sponsoredData={topProductsSponsoredData}
    />
  ) : (
    <TopBannerProduct
      key={`top-product-${productId}`}
      sponsoredData={topProductsSponsoredData}
    />
  );
};
